import { create } from 'zustand';

interface ApiErrorDialogState {
    message: string | null;
    pending: string[];

    /** Добавляет сообщение для чтения пользователем */
    show: (message: string) => void;

    /** Закрывает текущее сообщение и открывает следующее */
    dismiss: () => void;
}

/** Хранит сообщения API, которые пользователь должен прочитать */
export const useApiErrorDialog = create<ApiErrorDialogState>((set) => ({
    message: null,
    pending: [],

    show: (message) => set((state) => {
        if (state.message === message || state.pending.includes(message)) return state;
        if (state.message === null) return { message };
        return { pending: [...state.pending, message] };
    }),

    dismiss: () => set((state) => ({
        message: state.pending[0] ?? null,
        pending: state.pending.slice(1),
    })),
}));
